@if (user()?.loggedIn && !hideLayout) {
  @if (isMobile()) {
    <snag-layout-mobile>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </snag-layout-mobile>
  } @else {
    <hub-layout-desktop
      role="main"
      [isTabletLarge]="isTabletLarge()"
      [configuration]="configuration"
      [showAdminLogo]="showAdminLogo"
      [isEmployerApp]="enableTopNav">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </hub-layout-desktop>
  }
} @else if (!user()?.loggedIn || (user()?.loggedIn && hideLayout)) {
  <div class="no-layout">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<!-- MUST BIND TO A TEMPLATE IN ORDER TO SWITCH OFF NG-CONTENT -->
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
